import type { Icon } from '@phosphor-icons/react/dist/lib/types';
import { ChartPie as ChartPieIcon } from '@phosphor-icons/react/dist/ssr/ChartPie';
import { GearSix as GearSixIcon } from '@phosphor-icons/react/dist/ssr/GearSix';
import { PlugsConnected as PlugsConnectedIcon } from '@phosphor-icons/react/dist/ssr/PlugsConnected';
import { User as UserIcon } from '@phosphor-icons/react/dist/ssr/User';
import { Users as UsersIcon } from '@phosphor-icons/react/dist/ssr/Users';
import { XSquare } from '@phosphor-icons/react/dist/ssr/XSquare';
import { BuildingOffice as BuildingOfficeIcon } from '@phosphor-icons/react/dist/ssr/BuildingOffice';
import { Files as FilesIcon } from '@phosphor-icons/react/dist/ssr/Files';
import { CubeFocus as CubeFocusIcon } from '@phosphor-icons/react/dist/ssr/CubeFocus';
import { Factory as FactoryIcon } from '@phosphor-icons/react/dist/ssr/Factory';

export const navIcons = {
  'chart-pie': ChartPieIcon,
  'gear-six': GearSixIcon,
  'plugs-connected': PlugsConnectedIcon,
  'x-square': XSquare,
  user: UserIcon,
  users: UsersIcon,
  organisations: BuildingOfficeIcon,
  projects: FilesIcon,
  framework: CubeFocusIcon,
  plants: FactoryIcon
} as Record<string, Icon>;
